<script setup lang="ts">
// Define props
defineProps({
    formHeadlineConfig: {
        type: Object,
        required: false,
        default: () => ({}),
        validator: (rawValue) => {
            return typeof rawValue?.title === 'string'
        }
    }
})
</script>

<template>
    <h2 class="form-headline" v-html="formHeadlineConfig.title" />
</template>

<style  lang="scss">
.form-headline {
    @include form-headline;

    .asterisk-icon {
        top: 6px;
        padding-inline-start: 2px;

        @include bp(medium1) {
            top: 0;
            padding-inline-start: 0;
        }
    }
}
</style>
